import { render } from "./email-status-popup.vue?vue&type=template&id=2581f6c3&scoped=true"
import script from "./email-status-popup.vue?vue&type=script&lang=js"
export * from "./email-status-popup.vue?vue&type=script&lang=js"

import "./email-status-popup.vue?vue&type=style&index=0&id=2581f6c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2581f6c3"]])

export default __exports__